import { config } from './environment';

export const authConfig = {
  domain: config.authDomain,
  audience: config.authAudience,
  clientId: config.authClientId,
};
